import { getV3GraphRange, getEcotronGraphUtcRange } from '../../date';

export default async (api, chartOptions, payload) => {
  try {
    const range =
      payload.deviceType === 'ecotron'
        ? getEcotronGraphUtcRange(payload.from, payload.to)
        : getV3GraphRange(payload.from, payload.to);

    const response = await api.post(
      `${payload.deviceType}/graph/${payload.topic}`,
      {
        from: range.from,
        to: range.to,
        paramList: payload.measurement.label
      }
    );

    const responseData = response.data;

    if (responseData && responseData.success === false) {
      const error = new Error(responseData.message || 'Graph request failed');
      error.response = response;
      throw error;
    }

    const measurementPoints = Array.isArray(responseData) ? responseData : [];

    const importRelation = await import('../graphYAxis');
    const relation = importRelation.relation();

    let yAxisIndex = relation[payload.measurement.yAxis];
    chartOptions.yAxis[yAxisIndex].visible = true;

    for (let i = 0; i < measurementPoints.length; i++) {
      chartOptions.series.push({
        yAxis: yAxisIndex,
        name:
          payload.measurement.label === 'Ref_Flt'
            ? measurementPoints[i].name
            : payload.measurement.fullform,
        data: measurementPoints[i].data,
        tooltip: { valueSuffix: payload.measurement.unit }
      });
    }
  } catch (error) {
    throw error;
  }
};
